<template>
  <div class="wrapper">
    <!-- <SideBar v-bind:page="'profile'"/> -->
    <div class="page1 profile">
      <div v-if="$store.getters.emailVerified" class="profile-photo">
        <div class="profile-photo-inner df fdr">
          <div class="profile-photo-image posrel">
            <img
              class="profile-image"
              v-if="$store.getters.userData.profileImage"
              v-bind:src="$store.getters.userData.profileImage"
              alt
            />
            <img
              v-on:click="uploadPhotoStart()"
              src="/images/profile-icons/Edit-Profile-Pen.png"
              class="posabs edit-profile-icon"
              alt
            />
            <input
              v-on:change="uploadPhotoContinue()"
              ref="fileInput"
              id="fileUploadButton"
              style="opacity,: 0; width: 0; height: 0; position: absolute;"
              type="file"
            />
          </div>
          <div class="profile-photo-details df fdc jcc">
            <p class="profile-top-name">{{ $store.getters.userData.fullName }}</p>
            <p class="profile-top-email">{{ $store.getters.userData.email }}</p>

            <p
              v-if="fileWrongTypeMessageOn"
              class="warning-type"
            >Wrong type of file. Please use .jpg or .png.</p>
          </div>
        </div>
      </div>

      <div class="basic-profile" v-if="email">
        <h4 class="mt0">Contact Info</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Full Name</p>
            <input
              v-on:input="changesMade()"
              v-model="fullName"
              placeholder="Full Name"
              class="input1"
              type="text"
            />
          </span>
          <span class="input-wrapper df fdc">
            <p>Company</p>
            <input
              disabled
              v-on:input="changesMade()"
              placeholder="Company Name"
              v-bind:value="$store.getters.userData.companyName"
              class="input1"
              type="text"
            />
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Phone No.</p>
            <input
              v-on:input="changesMade()"
              v-mask="'###-###-####'"
              v-model="phone"
              placeholder="123-456-7890"
              class="input1"
            />
          </span>
          <span class="input-wrapper df fdc">
            <p v-bind:class="{ 'red-text': !$store.getters.emailVerified }">
              {{
              $store.getters.emailVerified
              ? "Email"
              : "Email - Awaiting Confirmation"
              }}
            </p>
            <input
              v-bind:class="{ 'red-text': !$store.getters.emailVerified }"
              disabled
              v-on:input="changesMade()"
              v-bind:value="$store.getters.userData.email"
              class="input1"
              type="text"
            />
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Address</p>
            <input v-on:input="changesMade()" v-model="address" class="input1" type="text" />
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text" />
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Country</p>
            <country-select
              v-on:input="changesMade()"
              v-model="country"
              :country="country"
              topCountry="US"
              class="input1 region-select"
            />
          </span>
          <span class="input-wrapper input-wrapper-row input-wrapper-inner df fdr">
            <span class="input-wrapper2 mb0i df fdc">
              <p>Province</p>
              <region-select
                v-on:input="changesMade()"
                v-model="province"
                :country="country"
                :region="province"
                :disablePlaceholder="true"
                class="input1 maxW region-select"
              />
            </span>
            <span class="input-wrapper2 mb0i df fdc">
              <p
                :class="invalidPostalCode ? 'error' : ''"
              >{{ invalidPostalCode ? 'Invalid' : '' }} Zip/Postal Code</p>
              <ZipPostalCodeInput
                class="input1"
                v-model="postalCode"
                :onError="invalidCode"
                :country="country"
                v-on:changesMade="changesMade()"
              />
            </span>
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc w100i">
            <button
              v-on:click="saveProfile()"
              class="button-form"
              v-bind:class="{ 'button-form-active': profileChangesMade && !invalidPostalCode }"
              :disabled="invalidPostalCode"
            >Save Changes</button>
          </span>
        </div>
      </div>

      <div v-if="$store.getters.emailVerified && email" class="change-password basic-profile">
        <h4 class="mt0">Change Password</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Enter Current Password</p>
            <p v-if="showError" class="error-message">Invalid password</p>
            <input
              v-model="currentPassword"
              ref="inputCurrentPassword"
              class="input1"
              type="password"
            />
          </span>
          <span class="input-wrapper df fdc"></span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Enter New Password</p>
            <input v-model="newPassword" class="input1" type="password" />
          </span>
          <span class="input-wrapper df fdc">
            <p>Confirm New Password</p>
            <input v-model="newPasswordRepeat" class="input1" type="password" />
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc w100i">
            <button
              v-on:click="updatePassword()"
              :disabled="(disableSubmit && validatePassword) || changePasswordSuccess"
              class="button-form button-form-active"
            >Change Password</button>
          </span>
        </div>
      </div>
      <p class="version">v0.1.21</p>
    </div>
    <SideBarProfile v-bind:page="'profile'" v-bind:editingCompany="'no'" />
  </div>
</template>

<script>
import SideBar from "@/components/elements/SideBar";
import SideBarProfile from "@/components/elements/SideBarProfile";
import ZipPostalCodeInput from "@/components/elements/ZipPostalCodeInput";

export default {
  name: "DashboardProfile",
  data() {
    return {
      profileChangesMade: false,
      fileWrongTypeMessageOn: false,
      company: "",
      user: {},
      currentPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
      cityProxy: "",
      invalidPostalCode: false,
      country: this.$store.getters.userData.country,
      province: this.$store.getters.userData.province,
      city: this.$store.getters.userData.city,
      phone: this.$store.getters.userData.phone,
      changePasswordSuccess: false,
      disableSubmit: true,
      showError: false
    };
  },
  props: [],
  components: {
    SideBarProfile,
    SideBar,
    ZipPostalCodeInput
  },
  watch: {
    "user.country"(val) {
      console.log(val, 123123);
    },
    email(val) {
      this.profileChangesMade = false;
    },
    country() {
      this.user.country = this.country;
    },
    province() {
      this.user.province = this.province;
    },
    city() {
      this.user.city = this.city;
    },
    phone() {
      this.user.phone = this.phone;
    },
    newPassword() {
      if (this.validatePassword()) {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    },
    newPasswordRepeat() {
      if (this.validatePassword()) {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    },
    currentPassword() {
      if (this.validatePassword()) {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    }
  },
  computed: {
    email() {
      return this.$store.getters.userData.email;
    },
    fullName: {
      get() {
        return this.$store.getters.userData.fullName;
      },
      set(val) {
        console.log("111", val);
        this.user.fullName = val;
      }
    },
    address: {
      get() {
        return this.$store.getters.userData.address;
      },
      set(val) {
        this.user.address = val;
      }
    },
    postalCode: {
      get() {
        return this.$store.getters.userData.postalCode;
      },
      set(val) {
        this.user.postalCode = val;
      }
    }
  },
  methods: {
    validatePassword() {
      if (
        this.newPassword.length < 6 ||
        this.currentPassword.length < 6 ||
        this.newPassword !== this.newPasswordRepeat
      ) {
        return false;
      }
      return true;
    },
    changesMade() {
      console.log("profileChangesMade");
      this.profileChangesMade = true;
    },
    invalidCode(val) {
      this.invalidPostalCode = val;
    },
    deleteAccount() {
      var data = {};
      this.$store.dispatch("deleteUser", data).then(() => {
        console.log("After deleting user");
      });
    },
    updatePassword() {
      console.log("before update password");
      if (this.validatePassword()) {
        var data = {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        };
        this.disableSubmit = true;
        this.$store
          .dispatch("updatePassword", data)
          .then(() => {
            // this.profileChangesMade = false
            this.currentPassword = "";
            this.newPassword = "";
            this.newPasswordRepeat = "";
            this.showError = false;
            console.log("After setting new password");
          })
          .catch(error => {
            if ((error.code = "auth/wrong-password")) {
              this.showError = true;
              this.$refs.inputCurrentPassword.focus();
            }
          });
      }
    },
    deletePhoto() {
      var data = { uid: this.$store.getters.uid };
      this.$store.dispatch("deletePhoto", data).then(() => {
        console.log("After deleting photo");
      });
    },
    uploadPhotoStart() {
      console.log("start photo upload");
      this.$refs.fileInput.click();
    },
    uploadPhotoContinue() {
      console.log("continue uploading photo");
      var inputElement = document.getElementById("fileUploadButton");
      var fileList = inputElement.files;
      if (fileList[0]) {
        console.log("THE FILE", fileList[0]);
        if (
          fileList[0].type == "image/png" ||
          fileList[0].type == "image/jpeg" ||
          fileList[0].type == "image/jpg"
        ) {
          var data = {
            file: fileList[0],
            uid: this.$store.getters.uid
          };
          console.log("file exists");
          this.fileWrongTypeMessageOn = false;
          this.$store.dispatch("saveProfileImage", data).then(() => {
            // this.profileChangesMade = false
          });
        } else {
          this.fileWrongTypeMessageOn = true;
          console.log("file is wrong type");
        }
      }
    },
    saveProfile() {
      if (this.profileChangesMade && !this.invalidPostalCode) {
        var data = {
          uid: this.$store.getters.uid,
          company: this.$store.getters.userData.companyName,
          email: this.$store.getters.userData.email,
          ...this.user
        };
        this.$store
          .dispatch("saveProfile", data)
          .then(() => (this.profileChangesMade = false));
      }
    }
  },
  created() {
    console.log("current user data", this.$store.getters.userData);
    document.onkeydown = checkKey;
    var _this = this;
    function checkKey(e) {
      console.log("enter", e.keyCode == "13");
      e = e || window.event;
      if (e.keyCode == "13" && _this.profileChangesMade) {
        console.log("enter2");
        e.preventDefault();
        _this.saveProfile();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";
h4 {
  /*margin-top: 75px;*/
  font-size: 16px;
  font-family: "Nexa";
  font-weight: 600;
  margin-bottom: 5px;
}
.error {
  color: red !important;
}
button:disabled,
button[disabled] {
  cursor: not-allowed !important;
}

//
// Wrapper
//
.wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  padding-left: 50px;
  padding-right: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding-left: 0px;
    padding-right: 0px;
  }
}

//
// Page 1
//
.page1 {
  width: calc(100% - 274px);

  // Responsive Style
  // @media max-width: 1024px
  @media (max-width: 1024px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    width: 100%;
  }
}

//
// Form Row
//
.form-row {
  width: 100%;

  // Responsive Style
  // @media max-width: 1024px
  @media (max-width: 1024px) {
    // display: block;
    flex-wrap: wrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    display: block;
  }
}

.input-wrapper2 {
  width: calc(50% - 10px);
  min-width: 0px;
  flex-direction: column-reverse;
}
.input-wrapper {
  max-width: calc(50% - 40px);
  flex: 1;
  flex-direction: column-reverse;
}
.input-wrapper,
.input-wrapper2 {
  margin-bottom: 10px;
  margin-right: 40px;

  & > p {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
    font-size: 12px;
    font-family: "GG";
    font-weight: 300;
    padding-left: 4px;
    overflow: visible;
    white-space: nowrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    display: block;
    width: auto;
    max-width: unset;
    margin-right: 0;

    // input & select
    input,
    select {
      display: block;
      width: 100%;
    }
  }
}

.input-wrapper-inner {
  flex: 1px;
  width: 50%;

  & > span {
    margin-right: 0;

    &:first-child {
      margin-right: 30px;
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    flex: none;
    width: auto;

    // span first child
    > span:first-child {
      margin-right: 0px;
    }
  }
}

.delete-account-text {
  color: #000000;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
  margin-bottom: 30px;
}

.profile-photo-inner {
  /*border-radius: 8px;*/
  /*background-color: white;*/
  /*padding: 50px;*/

  margin-bottom: 15px;
  margin-right: 30px;
  /*box-shadow: 0 1px 4px 0 rgba(0,0,0,0.32);*/

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    margin-right: 0;
  }
}

.profile-photo-details {
  flex: 1;
  margin-left: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    margin-left: 20px;
  }
}

.photo-buttons {
  & > button {
    &:first-child {
      margin-right: 40px;
    }
  }
}
.input-wrapper-row {
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}
.red-text {
  color: #d84647 !important;
}
.version {
  margin-top: 20px;
}
.warning-type {
  text-align: right;
  color: red;
  margin-top: 20px;
}

//
// Basic Profile
//
.basic-profile {
  max-width: 570px;
  margin-left: auto;
  margin-right: auto;

  // Responsive Style
  // @media max-width: 1024px
  @media (max-width: 1024px) {
    // width: auto;
    max-width: unset;
  }
}

.edit-profile-icon {
  width: 24px;
  height: 24px;
  background-color: $grey2;
  border-radius: 50%;
  object-fit: none;
  right: 0;
  top: 0;
}
.profile-top-name {
  font-family: "Nexa";
  font-weight: 600;
  font-size: 24px;
  color: $grey2;
  margin-bottom: 6px;
}
.profile-top-email {
  font-family: "GG";
  font-weight: 400;
  font-size: 16px;
  color: $grey2;
}
.button-form {
  margin-top: 25px;
}
.change-password {
  margin-top: 50px;
}

.input1 {
  height: auto;
  padding: 10px;
}
button:disabled,
button[disabled] {
  cursor: not-allowed !important;
  background-color: #aca1f4;
}
.error-message {
  color: red !important;
}
</style>
